import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class FormField extends Vue {
  @Prop({ type: Boolean, default: true }) private readonly small!: boolean
  @Prop({ type: String, default: '' }) private readonly label!: string
  @Prop({ type: Boolean, default: false }) private readonly required!: boolean
  @Prop({ type: Boolean, default: true })
  private readonly hiddenRequiredInfo!: boolean
  @Prop({ type: Boolean, default: false }) private readonly disabled!: boolean
}
